import DTOEmpleadoInfo from "../../Componest/Catalogos/CatVacaciones/DTO/DTOEmpleadoInfo";
import DTOInsertVacaciones from "../../Componest/Catalogos/CatVacaciones/DTO/DTOInsertVacaciones";
import DTOVacaciones from "../../Componest/Catalogos/CatVacaciones/DTO/DTOVacaciones";
import DTOUpdateVacaciones from "../../Componest/Catalogos/CatVacaciones/DTO/DTOUpdateVacaciones";
import http from '../common/http-common'
import DTOEliminarVacaciones from "../../Componest/Catalogos/CatVacaciones/DTO/DTOEliminarVacaciones";
import DTODiaFestivo from "../../Componest/Catalogos/CatVacaciones/DTO/DTODiaFestivo";
import { string } from "yup";
import DTOPresolicitud from "../../Componest/Catalogos/CatVacaciones/DTO/DTOPresolicitud";
import { Http, Message } from "@mui/icons-material";
import PreRegistros from "../../Componest/Catalogos/CatVacaciones/DTO/PreRegistros";
import { EmpleadoVacacionesDTO } from "../../Componest/Catalogos/CatVacaciones/DTO/EmpleadoVacacionesDTO";
import DTOVacacionesInactivas from "../../Componest/Catalogos/CatVacaciones/DTO/DTOVacacionesInactivas";
class CatVacaciones {

    
    GetAllVacaciones(numEmpleado: string) {
        return http.get<DTOVacaciones[]>(
            `/Catalogos/CatalogoVacaciones/GetAllVacaciones`, 
            { params: { numEmpleado } } 
        );
    }
    
    
   

    GetAllVacacionesDetalle(numEmpleado: string) {
        return http.get<DTOVacaciones[]>(
            `/Catalogos/CatalogoVacaciones/GetAllVacacionesDetalle`, 
            { params: { numEmpleado } } 
        );
    }






    GetAllVacacionesAndDetalle(numEmpleado: string ) {
        return http.get<DTOVacaciones[]> (`/Catalogos/CatalogoVacaciones/GetVacacionesAndDetalle`,  {

            params: {numEmpleado}
        } ); 
    }
 
    GetPresolicitudes(idSupervisor: number){
      return http.get<DTOPresolicitud[]>(`/Catalogos/CatalogoVacaciones/GetPresolicitudes`, { params: {idSupervisor}})
    }

      GetPreRegistrosAnioSiguiente() {
  return http.get<PreRegistros[]>(`/Catalogos/CatalogoVacaciones/PreRegistrosAnioSiguiente`);
}


EliminarPreRegistro(id: number) {
  return http.delete(`/Catalogos/CatalogoVacaciones/DeletePreRegistro`, {
    params: { id }
  });
}




    getAllVacacionesInfo(numEmpleado: string) {
        return http.get<DTOEmpleadoInfo[]>( 
            `/Catalogos/CatalogoVacaciones/GetInfoVacaciones`, 
            { params: { numEmpleado } }
        );
    }
    

    getAllSoVacaciones(fechaInicio : string, FechaFin: string , FiltroTipo: string)
    {
      return http.get<DTOVacaciones[]> (
        `/Catalogos/CatalogoVacaciones/GetSoVacaciones`, 
        {params: {fechaInicio: fechaInicio, FechaFin: FechaFin, FiltroTipo: FiltroTipo}
      }
      ); 
    }

    getAllSoVacacionesAceptadas(fechaInicio: string, fechaFin: string )
      {
        return http.get<DTOVacaciones[]>(
          `/Catalogos/CatalogoVacaciones/GetSoVacacionesAceptadas`, 
           { params: { fechaInicio: fechaInicio, FechaFin: fechaFin}
          }
        ); 
      }

      

      getAllSoVacacionesPendientes(fechaInicio: string, fechaFin: string )
      {
        return http.get<DTOVacaciones[]>(
          `/Catalogos/CatalogoVacaciones/GetSoVacacionesPendientes`, 
           { params: { fechaInicio: fechaInicio, FechaFin: fechaFin}
          }
        ); 
      }


        getAllConcentradoVacaciones() {
      return http.get<EmpleadoVacacionesDTO[]>(
        `/Catalogos/CatalogoVacaciones/GetConcentradoVacaciones`
      );
    }


     getVacacionesInactivas(fechaInicio: string, fechaFin: string )
      {
        return http.get<DTOVacacionesInactivas[]>(
          `/Catalogos/CatalogoVacaciones/GetHistorialVacaciones`, 
           { params: { fechaInicio: fechaInicio, FechaFin: fechaFin}
          }
        ); 
      }


      marcarProcesadaRh(idVacacion: number, procesadaRh: boolean) {
    return http.post(
    `/Catalogos/CatalogoVacaciones/MarcarProcesadaRh`,
    null,
    {
      params: { idVacacion, procesadaRh }
    }
  );
  }


    
    putVacacionesEstado(id: number, nuevoEstado: string, comentario: string, fechaAceptacion?: string) {
  return http.put<DTOVacaciones[]>(
    `/Catalogos/CatalogoVacaciones/PutEstadoVacaciones`,
    null,
    {
      params: {
        id: id,
        nuevoEstado: nuevoEstado,
        comentario: comentario,
        fechaAceptacion: fechaAceptacion 
      },
    }
  );
}


      enviarNotificacionVacaciones(numEmpleado: string,   nombre: string,  correo: string, estado: string, comentario: string) {
        return http.post(
          '/Catalogos/CatalogoVacaciones/EnviarNotificacionVacaciones',
          null, 
          {
            params: {
              numEmpleado: numEmpleado,
              nombre : nombre, 
              correo: correo,
              estado: estado,
              comentario: comentario,
            },
          }
        );
      }
      

enviarNotificacionesPendientes() {
  return http.post('/Catalogos/CatalogoVacaciones/EnviarNotificacionesPendientes');
}



      

       UpdateVacaciones(DTOUpdateVacaciones : DTOUpdateVacaciones)
       {
        return http.post<DTOUpdateVacaciones[]>(
          '/Catalogos/CatalogoVacaciones/UpdateVacaciones', 
          DTOUpdateVacaciones,  
          { headers: {'Content-Type': 'application/json',  },  
        }
        ); 
       }



    PostInsertVacaciones(DTOInsertVacaciones: DTOInsertVacaciones) {
        return http.post<DTOInsertVacaciones[]>(
            '/Catalogos/CatalogoVacaciones/PostInsertVacaciones',
            DTOInsertVacaciones, 
            {
                headers: {
                    'Content-Type': 'application/json', 
                },
            }
        );
    }

     PostVacacionesAnioSiguiente(DTOInsertVacaciones: DTOInsertVacaciones) {
        return http.post<DTOInsertVacaciones[]>(
            '/Catalogos/CatalogoVacaciones/PostVacacionesAnioSiguiente',
            DTOInsertVacaciones, 
            {
                headers: {
                    'Content-Type': 'application/json', 
                },
            }
        );
    }
    

   PostInsertPresolicitudes(data: DTOPresolicitud) {
  return http.post<DTOPresolicitud[]>(
    '/Catalogos/CatalogoVacaciones/PostInsertPresolicitud', 
    data,
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
}

    


    DeleteVacaciones(DTOEliminarVacaciones: DTOEliminarVacaciones) {
      return http.delete<{ Message: string }>(
        '/Catalogos/CatalogoVacaciones/EliminarVacaciones',
        {
          data: DTOEliminarVacaciones, 
          headers: { 'Content-Type': 'application/json' },
        }
      );
    }
    
    DeletePresolicitudes(idpresolicitud: number, numEmpleado: string) {
  return http.delete<{ Message: string }>(
    `/Catalogos/CatalogoVacaciones/EliminarPresolicitudes?IdPresolicitd=${idpresolicitud}&NumEmpleado=${numEmpleado}`
  );
}



    GetDiaFestivos() 
    {
      return http.get<DTODiaFestivo[]>(
          `/Catalogos/CatalogoVacaciones/GetDiasFestivos`
      );
    }
    
    InsertUpdateDias(DTODiaFestivo: DTODiaFestivo) {
      return http.post<DTODiaFestivo[]>(
        '/Catalogos/CatalogoVacaciones/InsertUpdateDias',
        DTODiaFestivo,  
        {
          headers: {
            'Content-Type': 'application/json',  
          }
        }
      );
    }

    DeleteDiafestivo(Fecha : string) {
      return http.delete<{ Message: string }>(
        '/Catalogos/CatalogoVacaciones/DeleteDias',
        {params:   {
          Fecha : Fecha
        }}
        );

    }
    





    

    
   
}



export default new CatVacaciones()